export function getQuarterStartEndDates() { // 当前日期的季度和前一季度-开始和结束日期
    const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth(); // 月份从0开始，0表示1月

  // 计算当前季度
  const currentQuarter = Math.floor((month + 3) / 3);

  // 计算当前季度的开始月份和结束月份
  const currentStartMonth = (currentQuarter - 1) * 3;
  const currentEndMonth = currentStartMonth + 2;

  // 计算当前季度的开始日期和结束日期
  const currentStartDate = new Date(year, currentStartMonth, 1);
  const currentEndDate = new Date(year, currentEndMonth + 1, 0); // 下一个月的前一天

  // 计算上一个季度的开始月份和结束月份
  const previousQuarter = currentQuarter - 1;
  const previousStartMonth = (previousQuarter - 1) * 3;
  const previousEndMonth = previousStartMonth + 2;
  const previousStartYear = previousQuarter === 0 ? year - 1 : year;
  const previousEndYear = previousStartYear;

  // 计算上一个季度的开始日期和结束日期
  const previousStartDate = new Date(previousStartYear, previousStartMonth, 1);
  const previousEndDate = new Date(previousEndYear, previousEndMonth + 1, 0); // 下一个月的前一天

  // 格式化日期为YYYY-MM-DD格式
  const formatDate = (date) => {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  return {
    currentQuarterStart: formatDate(currentStartDate),
    currentQuarterEnd: formatDate(currentEndDate),
    previousQuarterStart: formatDate(previousStartDate),
    previousQuarterEnd: formatDate(previousEndDate)
  };
  }